module.exports = __webpack_public_path__ + "static/media/jett.c2277d68.png";